import * as Dialog from '@radix-ui/react-dialog';
import { ReactNode } from 'react';
import { Text } from './ui';
import { XIcon } from 'lucide-react';

export interface BaseModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

interface ModalProps extends BaseModalProps {
  children?: ReactNode | ReactNode[];
  title?: string;
  width?: number;
}

export function Modal({ open, onOpenChange, children, title, width = 800 }: ModalProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-transparent-dark-16 fixed inset-0 z-50 backdrop-blur-[2px]" />
        <Dialog.Content
          className="bg-base-white data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 border-transparent-dark-6 p-lg custom-scrollbar fixed top-[50%] left-[50%] z-50 flex max-h-4/5 w-full translate-x-[-50%] translate-y-[-50%] flex-col overflow-auto rounded-md border shadow-xs duration-200"
          style={{ maxWidth: width }}
        >
          {title && (
            <Dialog.Title asChild>
              <Text as="h2" variant="heading" strong className="mb-4xl">
                {title}
              </Text>
            </Dialog.Title>
          )}
          <Dialog.Close asChild className="top-lg right-lg absolute">
            <button
              type="button"
              className="text-neutral-muted outline-neutral-subtle transition-all"
            >
              <XIcon size={20} />
            </button>
          </Dialog.Close>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
